import { callGet, callPost, callDelete, callPut } from "../integrations/calls";
import { REQ } from "../../libs/constants";

export const getPartyByCoupon = async (data, token) => {
  return await callPost(`${REQ.CREDIT.GET_PARTY_CODE}`, data, token);
};

export const saveData = async (data, token) => {
  return await callPost(REQ.CREDIT.SAVE_DATA, data, token);
};

export const getDataByEnteredOn = async (enteredOn, shift, token) => {
  return await callGet(
    `${REQ.CREDIT.GET_DATA_BY_ENTEREDON}/${enteredOn}/${shift}`,
    token
  );
};

export const getDataByCoupon = async (coupon, token) => {
  return await callGet(`${REQ.CREDIT.GET_DATA_BY_COUPON}/${coupon}`, token);
};

export const getVehicalByParty = async (data, token) => {
  return await callPost(REQ.CREDIT.GET_VEHICAL_BY_PARTY, data, token);
};

export const getVehicalDetail = async (id, token) => {
  return await callGet(`${REQ.CREDIT.GET_VEHICAL_DETAIL}/${id}`, token);
};

export const getLatestCoupon = async (token) => {
  return await callGet(REQ.CREDIT.GET_LATEST_COUPON, token);
};

export const updateSale = async (data, token) => {
  return await callPut(`${REQ.CREDIT.UPDATE_SALE}/${data.id}`, data, token);
};

export const deleteSingleCoupon = async (id, token) => {
  return await callDelete(
    `${REQ.CREDIT.DELETE_SINGLE_COUPON}/${id}`,
    {},
    token
  );
};

export const deleteByDate = async (date, shift, token) => {
  return await callDelete(
    `${REQ.CREDIT.DELETE_BY_DATE}/${date}/${shift}`,
    {},
    token
  );
};

export const descCreditSale = async (token) => {
  return await callGet(REQ.CREDIT.ORDER_BY_DESC, token);
};

export const ascCreditSale = async (token) => {
  return await callGet(REQ.CREDIT.ORDER_BY_ASC, token);
};


export const oneDayPrevious = async (data, token) => {
    return await callPost(REQ.CREDIT.ONE_DAY_PRE, data, token);
  };

  export const oneDayNext = async (data, token) => {
    return await callPost(REQ.CREDIT.ONE_DAY_NEXT, data, token);
  };
